import { render } from "./userProfile.vue?vue&type=template&id=f1062a30"
import script from "./userProfile.vue?vue&type=script&lang=js"
export * from "./userProfile.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/base/header/user/userProfile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f1062a30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f1062a30', __exports__)) {
    console.log('reload')
    api.reload('f1062a30', __exports__)
  }
  
  module.hot.accept("./userProfile.vue?vue&type=template&id=f1062a30", () => {
    console.log('re-render')
    api.rerender('f1062a30', render)
  })

}


export default __exports__